/* eslint-disable react-hooks/rules-of-hooks */
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IState } from '../../../../store';
import { isEmpty, pathOr } from 'ramda';
import { Thumbnail } from './Thumbnail';
import { IVideoSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { trackTourCards } from './analytics/trackTourCards';
import { showFullScreen } from '../../../../store/gallery';
import { IconVideo } from './Icons/IconVideo';
import { photosSelector } from './selectors/photosSelector';

export const videoThumbnailSelector = (state: IState): string | null => {
  return pathOr(null, ['offerData', 'tourV2', 'video', 'thumbnail'], state);
};

export const videoSelector = (state: IState): IVideoSchema[] => {
  return pathOr([], ['offerData', 'offer', 'videos'], state);
};

export const VideoThumbnailContainer = () => {
  const photos = useSelector(photosSelector);
  const video = useSelector(videoSelector);
  const videoThumbnail = useSelector(videoThumbnailSelector);
  const dispatch = useDispatch();

  if (isEmpty(video) || !videoThumbnail) {
    return null;
  }

  const videoIndex = photos.length;

  const planHandler = React.useCallback(() => {
    trackTourCards('video_photo_block');
    dispatch(showFullScreen(videoIndex || 0));
  }, []);

  return (
    <Thumbnail
      onClick={planHandler}
      img={videoThumbnail}
      imgSize="180%"
      text="Видео о комплексе"
      icon={<IconVideo />}
    />
  );
};

VideoThumbnailContainer.displayName = 'VideoThumbnailContainer';
